import { useRoleStore } from '@/stores/role';
import { ROLES, ROLE_ORDER, type RoleId } from '@/data/roles';
import { Icon } from '@/design-system/icons/Icon';
import { cx } from '@/utils/cx';
import { useNavigate } from 'react-router-dom';

export const RoleSeg = () => {
  const role = useRoleStore((s) => s.role);
  const setRole = useRoleStore((s) => s.setRole);
  const navigate = useNavigate();

  const onPick = (next: RoleId) => {
    setRole(next);
    navigate(ROLES[next].home);
  };

  return (
    <div className="role-switch">
      <span className="role-switch-label">Ver como</span>
      <div className="role-switch-seg" style={{ gridTemplateColumns: `repeat(${ROLE_ORDER.length}, 1fr)` }}>
        {ROLE_ORDER.map((r) => {
          const def = ROLES[r];
          return (
            <button
              key={r}
              type="button"
              onClick={() => onPick(r)}
              className={cx('role-seg', role === r && 'active')}
              title={def.label}
            >
              <Icon name={def.icon} size={17} className="ic" />
              <span>{def.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
